import React from 'react';
import { Chart } from 'react-chartjs-2';
import block from 'bem-cn';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

import { useChartModel } from 'components/Charts/data/model';

import './LineChart.scss';

ChartJS.register(
  LinearScale,
  LineController,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Filler,
);

const b = block('line-chart');

export const LineChart = ({ labels, originalLabels, originalLabels2, data, secondData, title, color, secondColor, colorFill, secondColorFill, isMobile }) => {
  const model = useChartModel({ labels, originalLabels, originalLabels2, data, secondData, title, color, secondColor, colorFill, secondColorFill, isMobile });

  return (
    <div className={b()}>
      <Chart type="line" options={model.options} data={model.data} />
    </div>
  );
};
